module.exports = __webpack_public_path__ + "img/OldDiningRoom.72f05d47.png";